<template>
    <div :class="[ isMobile ? 'featured-item' : 'gallery-item mb-4' ]">
        <div v-if="!isMobile">
            <div class="gallery-item-image-container cursor-pointer" @click="goItemDetail()">
                <img class="gallery-item-image" :src="item.mainImage.path" :alt="item.name">
            </div>

            <div class="gallery-item-details">
                <span class="gallery-item-name fs-20 color-primary-n cursor-pointer" @click="goItemDetail()">{{ item.name }}</span>
                <span class="subname">{{ item.subname }}</span>
                <div class="gallery-item-value fs-18 cursor-pointer" @click="goItemDetail()">
                    {{ item.price | moneyFilter }}
                    <span class="offert-price" v-if="item.e_base_offer_price > 0">{{ item.e_base_offer_price | moneyFilter }}</span>
                </div>
                <div class="row mt-2">
                    <div class="col-5 pr-0">
                        <inertia-link :href="route('item.detail', item.id)" as="button" class="btn btn-block btn-secondary-n">Ver</inertia-link>
                    </div>

                    <div class="col-7">
                        <button class="btn btn-block btn-primary-n"
                                @click.prevent="buyItem()">
                            Comprar
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="featured-item mb-0"  v-else>
            <div class="featured-item-image cursor-pointer" @click="goItemDetail()">
                <img :src="item.mainImage.path" :alt="item.name">
            </div>
            <div class="featured-item-info">
                <h4 class="fi-title color-primary-n cursor-pointer" @click="goItemDetail()">{{ item.name | nameLengthFilter }}</h4>
                <span class="fi-price cursor-pointer" @click="goItemDetail()">{{ item.price | moneyFilter }}</span>
                <div class="featured-item-options">
                    <inertia-link :href="route('item.detail', item.id)" class="featured-item-eye"><i class="fe-eye"></i></inertia-link>
                    <a class="featured-item-cart" @click.prevent="buyItem()"><i class="fe-shopping-cart"></i></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { ITEM_TYPES } from '../../../globlas';

import filtersMixin from '../../../mixins/filtersMixin';

export default {

    mixins: [

        filtersMixin,

    ],

    props: {

        item: {

            type: Object,
            required: true,

        },

    },

    data() {

        return {

        };

    },

    methods: {

        ...mapActions([

            'addItemToShoppingCart',

        ]),

        buyItem() {

            if (this.item.is_variation == 1) {

                this.$inertia.visit(this.route('item.detail', this.item.id));

                return;

            }

            const item = {

                id: this.item.id,
                uuid: this.item.uuid,
                code: this.item.code,
                reference: this.item.reference,
                inventoriable: this.item.inventoriable,
                inventory_quantity: this.item.inventory_quantity,
                quantity: 1,
                main_image: this.item.mainImage.path,
                name: this.item.name,
                price: this.item.price,
                price_no_tax: this.item.price_no_tax,
                tax_description: this.item.tax_desc,
                tax_id: this.item.tax_id,
                tax_percentage: this.item.tax_per,
                tax_type: this.item.tax_type,
                is_package: this.item.is_package,
                is_subscription: this.item.is_subscription,
                sub_freq: this.item.sub_freq,
                is_virtual: this.item.e_item_type == ITEM_TYPES.VIRTUAL,

            };

            this.addItemToShoppingCart(item);

            this.$inertia.visit(this.route('shopping.cart'));

        },

        goItemDetail() {

            if (this.item.id) {

                this.$inertia.visit(this.route('item.detail', this.item.id));

            }

        },

    },

};
</script>
